import { render, staticRenderFns } from "./Navi.vue?vue&type=template&id=4f2f2074&scoped=true"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"
import style0 from "./Navi.vue?vue&type=style&index=0&id=4f2f2074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f2074",
  null
  
)

export default component.exports